import React, { Component } from 'react';

export default class SpoiledTomatillosContent extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        return (

            <div>
                <p>
                  Spoiled Tomatillos was a semester-long project for my Software Development course at Northeastern University. With 4 of my classmates, we developed a web application similar to the movie review website, Rotten Tomatoes.
                </p>

                <p>
                  The purpose of the Spoiled Tomatillos Project in the context of my Software Development class was to focus on the software development process. Throughout the project, my teammates an I learned a lot about using Git, making pull requests, and conducting code reviews. We also explored many new technologies like AWS, Jenkins, React, and more.
                </p>

                <p>
                  Since everyone in my group had already been on one co-op, this was a great knowledge-sharing experience; some people in the group knew React very well, while others were more experienced in Java. Some group members were well-versed in git, while others had no experience with it, so it was a great learning experience for everyone.
                </p>

                <p>
                  My main role on the team was to set up and manage the team’s AWS server, Jenkins, and SonarQube services. I also spent time writing backend code (Java), and leading coordination of the various reports and other documents required by the course.
                </p>

                <p>
                  This class was a great exercise in keeping frequent communication with teammates. Overall, my group was very experienced and I am very happy not only with how the final product came out, but with how well we followed good practices to get there.
                </p>

                <p>
                  Unfortunately our SpoiledTomatillos project is not online for viewing anymore, but please checkout our quick walkthrough video!
                </p>

            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SpoiledTomatillosContent.jsx